'use client';

import { useState, type FC, type ReactNode } from 'react';
import { Button } from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

const PHONE_VISIBLE = 4;
const DESKTOP_VISIBLE = 12;
// WHY: прятать ради одной-двух карточек нелепо — сворачиваем, только если под кнопкой окажется заметная часть сетки
const PHONE_MIN_HIDDEN = 4;
const DESKTOP_MIN_HIDDEN = 6;

interface WikiCollapsibleGridProps {
  count: number;
  label: string;
  children: ReactNode;
  className?: string;
}

// WHY: длинная сетка скинов отодвигала статью на десятки экранов; до нажатия видны два ряда, остальные карточки в разметке для поисковика, скрыты только визуально
export const WikiCollapsibleGrid: FC<WikiCollapsibleGridProps> = ({ count, label, children, className }) => {
  const [expanded, setExpanded] = useState(false);
  const phone = !expanded && count - PHONE_VISIBLE >= PHONE_MIN_HIDDEN;
  const desktop = !expanded && count - DESKTOP_VISIBLE >= DESKTOP_MIN_HIDDEN;
  return (
    <div
      className={cn(
        'flex flex-col gap-3',
        phone && 'max-lg:[&>ul>li:nth-child(n+5)]:hidden',
        desktop && 'lg:[&>ul>li:nth-child(n+13)]:hidden',
        className,
      )}
    >
      {children}
      {(phone || desktop) && (
        <Button
          type="button"
          variant="secondary"
          size="l"
          onClick={() => setExpanded(true)}
          className={cn('w-full sm:w-auto sm:self-center sm:px-8', !phone && 'max-lg:hidden', !desktop && 'lg:hidden')}
        >
          {label}
        </Button>
      )}
    </div>
  );
};
